import { IBaseDataParser } from '../../../../vendor_core/core/src/server/parsers/IBaseDataParser';
import ICoinData from '../../../model/ICoinData';

export default class CRCCoinDataParser implements IBaseDataParser<ICoinData> {
    public check(data: any): boolean {
        return data;
    }

    public parse(data: any): ICoinData[] {
        if (data.refresh) {
            data = data.refresh;
        }

        const state = this.getState(data?.stateAfterMainSpin?.meter)

        let result: ICoinData = {
            endState: state,
            isCoinRainPlayed: false
        };


        return [result];
    }

    private getState(stateAfterMainSpin: number = 0): number {
        let result = 0;

        if (stateAfterMainSpin > 0 && stateAfterMainSpin < 3) {
            result = 1;
        } else if (stateAfterMainSpin >= 3 && stateAfterMainSpin < 6) {
            result = 2;
        } else if (stateAfterMainSpin >= 6 && stateAfterMainSpin < 10) {
            result = 3;
        } else if (stateAfterMainSpin >= 10 && stateAfterMainSpin < 14) {
            result = 4;
        } else if (stateAfterMainSpin >= 14 && stateAfterMainSpin < 20) {
            result = 5;
        } else if (stateAfterMainSpin >= 20 && stateAfterMainSpin < 27) {
            result = 6;
        } else if (stateAfterMainSpin >= 27 && stateAfterMainSpin < 35) {
            result = 7;
        } else if (stateAfterMainSpin >= 35 && stateAfterMainSpin < 45) {
            result = 8;
        } else if (stateAfterMainSpin >= 45 && stateAfterMainSpin < 55) {
            result = 9;
        } else if (stateAfterMainSpin >= 55 && stateAfterMainSpin < 68) {
            result = 10;
        } else if (stateAfterMainSpin >= 68 && stateAfterMainSpin < 80) {
            result = 11;
        } else if (stateAfterMainSpin >= 80 && stateAfterMainSpin < 95) {
            result = 12;
        } else if (stateAfterMainSpin >= 95 && stateAfterMainSpin < 115) {
            result = 13;
        } else if (stateAfterMainSpin >= 115 && stateAfterMainSpin < 130) {
            result = 14;
        } else if (stateAfterMainSpin >= 130 && stateAfterMainSpin < 150) {
            result = 15;
        } else if (stateAfterMainSpin >= 150) {
            result = 16;
        };

        return result

    }
}
